import type React from "react";

import type { LanguageDto } from "@/api/types";

export function FlagIcon({ size = 16, languageId }: { size?: number; languageId: LanguageDto["id"] }): React.ReactNode {
  // https://flagicons.lipis.dev/
  switch (languageId) {
    case "de":
      return (
        <svg width={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" className="shrink-0">
          <path fill="#ffce00" d="M0 320h640v160H0z" />
          <path d="M0 0h640v160H0z" />
          <path fill="#d00" d="M0 160h640v160H0z" />
        </svg>
      );
    case "nl":
      return (
        <svg width={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" className="shrink-0">
          <path fill="#21468b" d="M0 0h640v480H0z" />
          <path fill="#fff" d="M0 0h640v320H0z" />
          <path fill="#ae1c28" d="M0 0h640v160H0z" />
        </svg>
      );
    case "en":
      return (
        <svg width={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" className="shrink-0">
          <path fill="#012169" d="M0 0h640v480H0z" />
          <path
            fill="#FFF"
            d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
          />
          <path
            fill="#C8102E"
            d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
          />
          <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z" />
          <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" />
        </svg>
      );
    default:
      // empty icon
      return (
        <svg width={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" className="shrink-0">
          <path fill="#fff" fillRule="evenodd" stroke="#adb5bd" strokeWidth="1.1" d="M.5.5h638.9v478.9H.5z" />
          <path fill="none" stroke="#adb5bd" strokeWidth="5" d="m.5.5 639 479M639.5.5l-639 479" />
        </svg>
      );
  }
}
